/* global Office, fetch */

// URL backendu (musi sedet s AppDomain v manifestu).
const BACKEND = "https://qrcal1.qrentry.app";
// Docasny sdileny klic (hardening: nahradit Office SSO).
const ADDIN_KEY = "472ab223-79e4-4070-b877-9f97344baed5081eb1f9154e48b69971cf52a7ec0380";

Office.onReady((info) => {
  if (info.host !== Office.HostType.Outlook) return;
  document.getElementById("send").onclick = sendQr;
  showMeeting();
});

// Pomocnik: zabali callback-style Office.js getAsync do Promise.
function getAsync(getter) {
  return new Promise((resolve) => {
    try {
      getter((r) =>
        resolve(r.status === Office.AsyncResultStatus.Succeeded ? r.value : null)
      );
    } catch {
      resolve(null);
    }
  });
}

// Nahled schuzky v task pane (jen informativni; autoritativni data si bere backend z Graphu).
async function showMeeting() {
  const item = Office.context.mailbox.item;
  const [subject, start, end, req, opt] = await Promise.all([
    getAsync((cb) => item.subject.getAsync(cb)),
    getAsync((cb) => item.start.getAsync(cb)),
    getAsync((cb) => item.end.getAsync(cb)),
    getAsync((cb) => item.requiredAttendees.getAsync(cb)),
    getAsync((cb) => item.optionalAttendees.getAsync(cb)),
  ]);
  const attendees = [...(req || []), ...(opt || [])];
  document.getElementById("subject").textContent = subject || "(bez předmětu)";
  document.getElementById("when").textContent =
    start && end
      ? `${new Date(start).toLocaleString("cs-CZ")} – ${new Date(end).toLocaleTimeString("cs-CZ")}`
      : "—";
  document.getElementById("count").textContent = `${attendees.length} účastníků`;
}

// Spusti vydani QR. Add-in posila jen IDENTITU schuzky + SSO token;
// ucastniky, datum/cas i rozeslani resi backend pristupoveho systemu.
async function sendQr() {
  const btn = document.getElementById("send");
  const status = document.getElementById("status");
  btn.disabled = true;
  status.textContent = "Odesílám…";
  try {
    const item = Office.context.mailbox.item;

    // iCalUid je stabilni klic schuzky; organizer = prihlaseny uzivatel.
    const iCalUid = item.iCalUid;
    const organizer = Office.context.mailbox.userProfile.emailAddress;

    const res = await fetch(`${BACKEND}/api/issue-qr`, {
      method: "POST",
      headers: {
        "X-Addin-Key": ADDIN_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ iCalUid, organizer }),
    });

    const data = await res.json().catch(() => ({}));
    status.textContent = res.ok
      ? `Hotovo – QR odesláno ${data.attendees} účastníkům.`
      : `Chyba: ${data.error || res.status}`;
  } catch (e) {
    status.textContent = `Chyba: ${e.message || e}`;
  } finally {
    btn.disabled = false;
  }
}
